import React from "react";
import { Link } from "react-router-dom";
import AboutCompo from "../components/AboutCompo/AboutCompo";
import Countup from "../components/Countup/Countup";

const About = () => {
  return (
    <div>
      {/* Hero Section */}
      <div className="relative bg-zinc-800 text-white h-[40vh]">
        <img
          src="/assets/about/about.avif"
          alt="ourproject background"
          className="absolute inset-0 w-full h-full object-cover opacity-60"
        />
        <div className="relative z-10 p-8 flex flex-col items-center">
          <nav className="flex space-x-4 text-sm">
            <Link to="/" className="text-gray-300 hover:text-white">
              Home
            </Link>
            <span className="text-gray-300">/</span>
            <Link to="/about" className="text-gray-300 hover:text-white">
              About
            </Link>
          </nav>
          <h1 className="text-4xl font-bold mt-4">ABOUT JS</h1>
        </div>
      </div>
      
      <div>
        <AboutCompo />
      </div>
      
      <div>
        {/* Happy client section */}
        <Countup />
      </div>
    </div>
  );
};

export default About;
